import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgMenuSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M15 3H1M15 13H1M15 8H1"
      stroke={props.color}
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
  </svg>
);

SvgMenuSmall.displayName = 'SvgMenuSmall';
const MenuSmall = withForgeIconProps(SvgMenuSmall, {
  name: 'Menu',
  usage: 'Use to open a menu or as a top level nav in mobile.',
  related: 'hamburger, flyout, popover, navigation',
  isLabelRequired: false,
  isNeutralInteractive: false,
  size: 'small',
});
export default MenuSmall;
